import React from 'react';

const CustomTooltip = ({ active, payload, label, labelFormatter, valueFormatter, colorKey = 'color' }) => {
    if (active && payload && payload.length) {
        const ApplicationStatusLabel = ['Pending', 'Rejected', 'Approved']
        return (
            <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: 4, padding: 8, fontSize: 12 }}>
                <p style={{ margin: 0, fontWeight: 'bold', color: '#000' }}>
                    {labelFormatter ? labelFormatter(label) : label}
                </p>
                {payload.map((entry, index) => (
                    <div key={`tooltip-item-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                        <span
                            style={{
                                display: 'inline-block',
                                width: 12,
                                height: 12,
                                backgroundColor: ApplicationStatusLabel.includes(entry.name) ? entry.payload.color : entry[colorKey],
                                marginRight: 8,
                                borderRadius: 2,
                            }}
                        />
                        <span style={{ color: '#000', textTransform: 'capitalize', }}>
                            {entry.name}: {valueFormatter ? valueFormatter(entry.value) : entry.value}
                        </span>
                    </div>
                ))}
            </div>
        );
    }

    return null;
};

export default CustomTooltip;